"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormColorPickerField = void 0;
const color_picker_1 = require("../../../components/color-picker/color-picker");
const form_field_1 = require("./form-field");
exports.FormColorPickerField = (0, form_field_1.formFieldFactory)(color_picker_1.ColorPickerField);
//# sourceMappingURL=form-color-picker-field.js.map